<template lang="pug">
  .container.grid-xl
    page-title(title="Afiliado" icon="fas fa-handshake" subtitle="Detalhes do afiliado")
      div(slot="actions")
        router-link.btn.btn-link.tooltip.tooltip-left.mr-2(
          :to="{ name: 'filiations.balance.purchases' }"
          data-tooltip="Balanço"
        )
          i.fas.fa-balance-scale-right.fa-lg
    .flex-centered.content-full-height(v-if="loading") #[.loading.loading-lg]
    .columns(v-else-if="!error && filiation")
      .column.col-12(v-if="filiation.author")
        .toast.toast-info
          | O autor #[span.text-bold {{ filiation.author.name }}] está vinculado a este afiliado
      .column.col-12.mb-2.pb-2
        resume(:filiation="filiation")
      .column.col-4.col-md-6.col-sm-12.mb-2.pb-2
        blockquote
          .columns
            .column.col-auto
              user-avatar.avatar-lg(:user="filiation.person")
            .column.text-ellipsis
              .text-bold.text-ellipsis {{ filiation.person.fullName }}
              .text-small.text-ellipsis {{ filiation.person.email }}
              small.label(:class="filiation.active ? 'label-success' : 'label-error'") {{ filiation.active ? 'Ativo' : 'Inativo' }}
    .flex-centered.content-full-height(v-else-if="error") #[error-box(:error="error")]
</template>

<script>
import filiations from '@/services/filiations'
import Resume from './components/Resume'

export default {
  data() {
    return { loading: false, error: null, filiation: null }
  },
  components: { Resume },
  methods: {
    async fetchFiliated() {
      try {
        this.loading = true
        const { data } = await filiations.show(this.$route.params.id)
        this.filiation = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchFiliated()
  },
}
</script>
